import { useAuth } from "@/lib/auth-context";
import { useState } from "react";

// ============================================================
// Login Page
// ============================================================

export function LoginPage() {
	const { login } = useAuth();
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(false);

	async function handleSubmit(e: React.FormEvent) {
		e.preventDefault();
		setError("");
		setLoading(true);

		try {
			await login(email, password);
		} catch {
			setError("E-Mail oder Passwort falsch.");
		} finally {
			setLoading(false);
		}
	}

	return (
		<div className="flex h-full items-center justify-center bg-stone-50 px-4">
			<div className="w-full max-w-sm animate-fade-in">
				{/* Logo */}
				<div className="mb-8 text-center">
					<div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-xl bg-brand-600 font-display text-lg text-white shadow-lg shadow-brand-600/25">
						bh
					</div>
					<h1 className="font-display text-2xl">Booking Hub</h1>
					<p className="mt-1 text-sm text-stone-500">
						as.if.spaces — Buchungsverwaltung
					</p>
				</div>

				{/* Form */}
				<form onSubmit={handleSubmit} className="card space-y-4">
					{error && (
						<div className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">
							{error}
						</div>
					)}

					<div>
						<label
							htmlFor="email"
							className="mb-1.5 block text-sm font-medium text-stone-700"
						>
							E-Mail
						</label>
						<input
							id="email"
							type="email"
							required
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							className="input"
							placeholder="hello@as-if-records.com"
							autoComplete="email"
						/>
					</div>

					<div>
						<label
							htmlFor="password"
							className="mb-1.5 block text-sm font-medium text-stone-700"
						>
							Passwort
						</label>
						<input
							id="password"
							type="password"
							required
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							className="input"
							autoComplete="current-password"
						/>
					</div>

					<button
						type="submit"
						disabled={loading}
						className="btn-primary w-full disabled:opacity-50"
					>
						{loading ? "Einloggen..." : "Einloggen"}
					</button>
				</form>
			</div>
		</div>
	);
}
